import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import {
    ShButtonComponent,
    ShInputTextComponent,
    ShSelectComponent,
    ShSelectOption,
    SHUI_MODAL_CONFIG,
    ShuiModalConfig,
    ShuiModalRef,
    TextValueAccessor
} from '@gbr-monorepo/gbr-shui';
import { TranslateModule } from '@ngx-translate/core';
import { User, Roles } from '@gbr-monorepo/interfaces';

@Component({
    selector: 'app-edit-user-dialog',
    templateUrl: './edit-user.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ShInputTextComponent,
        ShSelectComponent,
        ShButtonComponent,
        TextValueAccessor,
        TranslateModule
    ]
})
export class EditUserComponent {
    private readonly config = inject<ShuiModalConfig<{ user: User; delegatesEnabled: boolean }>>(SHUI_MODAL_CONFIG);
    private readonly dialogRef = inject<ShuiModalRef<{ confirmed: boolean; payload?: User }>>(ShuiModalRef);
    private readonly formBuilder = inject(FormBuilder);

    protected editUserForm: FormGroup;
    protected loading = false;
    private readonly delegatesEnabled = !!this.config.data?.delegatesEnabled;
    private readonly user = this.config.data?.user as User;
    protected readonly roleOptions: ShSelectOption[] = Object.values(Roles)
        .filter(role => this.delegatesEnabled || role !== Roles.DELEGATE)
        .map(role => ({ value: role, label: role }));

    constructor() {
        this.editUserForm = this.buildEditForm();
    }

    protected editUser(): void {
        const userToEdit: User = {
            gid: this.editUserForm.controls['gid'].value,
            firstName: this.editUserForm.controls['firstName'].value,
            lastName: this.editUserForm.controls['lastName'].value,
            roles: this.editUserForm.controls['roles'].value,
            email: this.editUserForm.controls['email'].value
        };
        this.dialogRef.close({ confirmed: true, payload: userToEdit });
    }

    protected cancel(): void {
        this.dialogRef.close({ confirmed: false });
    }

    private buildEditForm(): FormGroup {
        return this.formBuilder.group({
            gid: [{ value: this.user.gid, disabled: true }],
            firstName: [this.user.firstName, Validators.required],
            lastName: [this.user.lastName, Validators.required],
            email: [this.user.email, [Validators.required, Validators.email]],
            roles: [this.user.roles]
        });
    }
}
